import CmsEditorCenter from './CmsEditorCenter'
import CmsEditorLeft from './CmsEditorLeft'
import CmsEditorTop from './CmsEditorTop'
import './CmsEditor.css'

const CmsEditor = () => {
  return (
    <div className='cmsEditor'>
      <div className='cmsEditorTop'>
        <CmsEditorTop />
      </div>
      <div className='cmsEditorLeft'>
        <CmsEditorLeft />
      </div>
      <div className='cmsEditorCenter overflow-y-scroll p-4 bg-white'>
        <CmsEditorCenter />
      </div>
    </div>
  )
}
export default CmsEditor
